module.exports = __webpack_public_path__ + "img/v5.a183c8e6.png";